import {
	faCheck,
	faExclamationCircle,
	faExclamationTriangle,
	faInfoCircle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import styled, { css } from 'styled-components'

export type MessageType = 'info' | 'warn' | 'error' | 'success'

type MessageProps = {
	header?: React.ReactNode,
	message: React.ReactNode,
	type?: MessageType
}

const typeToIcon = {
	info: faInfoCircle,
	warn: faExclamationTriangle,
	error: faExclamationCircle,
	success: faCheck,
} as const

export const Message = ({ type = 'info', message, header }: MessageProps) => {
	return (
		<MessageContainer data-testid={`message-${type}`}>
			<MessageTitle type={type} data-testid="message-title">
				<Icon data-testid="message-icon">
					<FontAwesomeIcon icon={typeToIcon[type]} />
				</Icon>
				<span data-testid="message-text">{header ? header : message}</span>
			</MessageTitle>
			{header && <HeaderMessage data-testid="message-header">{message}</HeaderMessage>}
		</MessageContainer>
	)
}

const MessageContainer = styled.div`
	box-shadow: 1px 0px 5px 0px #aaa;
	margin: 5px 0px 15px 0px;

	ul li {
		list-style-type: disc;
		margin-left: 20px;
	}

	code {
		background: #f5f5f5;
		padding: 0 5px;
		border-radius: 2px;
	}
`

const MessageTitle = styled.div<{ type: MessageType }>`
	${(props) => css`
		display: flex;
		align-items: center;
		justify-content: center;
		background: ${props.theme.colors.message[props.type].background};
		color: ${props.theme.colors.message[props.type].color};

		span {
			flex-grow: 1;
			padding: 10px 10px 10px 0;
		}
	`}
`

const HeaderMessage = styled.div`
	padding: 1rem;
`

const Icon = styled.div`
	padding: 10px;
`
